document
    .querySelectorAll('.h3p-carrousel-membres')
    .forEach((carousel) => {
        const viewport = carousel.querySelector(
            '[data-carousel-viewport]'
        );

        const previous = carousel.querySelector(
            '[data-carousel-previous]'
        );

        const next = carousel.querySelector(
            '[data-carousel-next]'
        );

        const track = carousel.querySelector(
            '.h3p-carrousel-membres__track'
        );

        if (!viewport || !previous || !next || !track) {
            return;
        }

        const getCards = () =>
            track.querySelectorAll('.h3p-membre');

        const getGap = () => {
            const styles = window.getComputedStyle(track);

            return parseFloat(
                styles.columnGap ||
                styles.gap ||
                '0'
            );
        };

        const getStep = () => {
            const firstCard = track.querySelector(
                '.h3p-membre'
            );

            if (!firstCard) {
                return viewport.clientWidth;
            }

            return (
                firstCard.getBoundingClientRect().width +
                getGap()
            );
        };

        const hasOverflow = () =>
            viewport.scrollWidth >
            viewport.clientWidth + 2;

        const updateLayout = () => {
            const overflow = hasOverflow();

            track.classList.toggle(
                'is-centered',
                !overflow
            );

            previous.hidden = !overflow;
            next.hidden = !overflow;

            if (!overflow) {
                previous.disabled = true;
                next.disabled = true;
                viewport.scrollLeft = 0;

                return;
            }

            const maxScroll =
                viewport.scrollWidth -
                viewport.clientWidth;

            previous.disabled =
                viewport.scrollLeft <= 2;

            next.disabled =
                viewport.scrollLeft >= maxScroll - 2;
        };

        const reducedMotion = () =>
            window.matchMedia(
                '(prefers-reduced-motion: reduce)'
            ).matches;

        previous.addEventListener('click', () => {
            viewport.scrollBy({
                left: -getStep(),
                behavior: reducedMotion()
                    ? 'auto'
                    : 'smooth',
            });
        });

        next.addEventListener('click', () => {
            viewport.scrollBy({
                left: getStep(),
                behavior: reducedMotion()
                    ? 'auto'
                    : 'smooth',
            });
        });

        viewport.addEventListener(
            'scroll',
            updateLayout,
            {
                passive: true,
            }
        );

        const resizeObserver =
            typeof ResizeObserver !== 'undefined'
                ? new ResizeObserver(updateLayout)
                : null;

        resizeObserver?.observe(viewport);
        resizeObserver?.observe(track);

        window.addEventListener(
            'resize',
            updateLayout
        );

        getCards().forEach((card) => {
            const image = card.querySelector('img');

            if (
                image &&
                !image.complete
            ) {
                image.addEventListener(
                    'load',
                    updateLayout,
                    {
                        once: true,
                    }
                );
            }
        });

        updateLayout();
    });
